import React from "react";

import { cn } from "../../../utils/cn";

type Props = {
  title: string;
  description?: string;
  /** Rendered top-right — usually a save button. */
  action?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
};

/**
 * The card every settings tab body is built from, so headings, padding and
 * borders stay identical across tabs instead of each one inventing its own.
 */
const SettingsSection = ({
  title,
  description,
  action,
  className,
  children,
}: Props) => (
  <section className={cn("rounded-xl border bg-card p-5 lgss:p-6", className)}>
    <div className="flex flex-col gap-3 mds:flex-row mds:items-start mds:justify-between">
      <div className="min-w-0">
        <h2 className="font-sora text-[16px] font-semibold text-foreground">
          {title}
        </h2>
        {description && (
          <p className="mt-1 text-[13px] font-medium text-muted-foreground">
            {description}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>

    <div className="mt-5">{children}</div>
  </section>
);

export default SettingsSection;
